import { render, staticRenderFns } from "./PageInfoPages.vue?vue&type=template&id=4ac69f5a&"
import script from "./PageInfoPages.vue?vue&type=script&lang=js&"
export * from "./PageInfoPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ac69f5a')) {
      api.createRecord('4ac69f5a', component.options)
    } else {
      api.reload('4ac69f5a', component.options)
    }
    module.hot.accept("./PageInfoPages.vue?vue&type=template&id=4ac69f5a&", function () {
      api.rerender('4ac69f5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/infoPages/PageInfoPages.vue"
export default component.exports